type NewRelicSimpleType = string | number | boolean | null | Error;

interface NewRelicApi {
  noticeError(error: string | Error, errorDetailsObj?: Record<string, NewRelicSimpleType>): void;
  setCustomAttribute(attribute: string, value: NewRelicSimpleType, persist?: boolean): void;
  addPageAction(actionName: string, eventDetailsObj?: Record<string, NewRelicSimpleType>): void;
}

declare global {
  interface Window {
    newrelic?: NewRelicApi;
  }
}

export const logErrorToNewRelic = (
  error: string | Error,
  errorDetailsObj?: Record<string, NewRelicSimpleType> | undefined
) => {
  if (window.newrelic) {
    window.newrelic.noticeError(error, errorDetailsObj);
  }
};

export const logCustomAttributeToNewRelic = (
  attribute: string,
  value: NewRelicSimpleType,
  persist?: boolean
) => {
  if (window.newrelic) {
    window.newrelic.setCustomAttribute(attribute, value, persist);
  }
};

export const logPageActionToNewRelic = (
  actionName: string,
  eventDetailsObj?: Record<string, NewRelicSimpleType> | undefined
) => {
  if (window.newrelic) {
    window.newrelic.addPageAction(actionName, eventDetailsObj);
  }
};
